import { PunchupButton } from "../../common/PunchupButton";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../shadcn/ui/tooltip";

interface ConfirmFooterProps {
  onClick: () => void;
  disabled?: boolean;
  isMobile: boolean;
  className?: string;
  tooltipText?: string;
}

export function ConfirmFooter({
  onClick,
  disabled,
  isMobile,
  className = "mt-4 flex justify-end",
  tooltipText,
}: ConfirmFooterProps) {
  if (isMobile) return null;

  const button = (
    <PunchupButton
      variant="outline"
      onClick={onClick}
      disabled={disabled}
      size="sm"
    >
      Confirm
    </PunchupButton>
  );

  if (tooltipText && disabled) {
    return (
      <div className={className}>
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>{button}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs">{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  return <div className={className}>{button}</div>;
}
